import React, {Component} from 'react';
import './Homepage.scss';

import Header from '../../Component/PagesComponent/Homepage/Header/Header';
import CatalogOptions from '../../Component/PagesComponent/Homepage/CatalogOptions/CatalogOptions';
import Values from '../../Component/PagesComponent/Homepage/Values/Values';
import PackagingCatalog from '../../Component/PagesComponent/Homepage/PackagingCatalog/PackagingCatalog';
import OrderInstruction from '../../Component/PagesComponent/Homepage/OrderInstruction/OrderInstruction';
import ConsultationBanner from '../../Component/PagesComponent/Homepage/ConsultationBanner/ConsultationBanner';

class Homepage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayValue: false
        }
    }
    
    componentDidMount() {
        window.addEventListener('resize', function(event){});
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        setTimeout(() => {
            this.setState({
                ...this.state,
                displayValue: true,
            });
        }, 5);
    }

    componentDidUpdate() {
        // window.scrollTo({
        //     top: 0,
        //     behavior: 'smooth'
        // });
    }
    
    componentWillUnmount() {
        this.setState = (state,callback)=>{
            return;
        };

        window.removeEventListener('resize', () => {});
    }

    render() {
        return (
            <div className="homepage">
                <Header />
                <CatalogOptions />
                <PackagingCatalog 
                    title={"SUDAH PUNYA DESIGN SENDIRI? CUSTOM SEKARANG."}
                    subtitle={
                        <>
                            Kalian bisa pilih sendiri produknya <strong className="packaging-catalog-subtitle-highlight">(DESIGN HANYA BISA 1 WARNA YA!)</strong>
                        </>
                    }
                    isReadyStock={0}
                />
                <PackagingCatalog 
                    elementId={"ready-stock"}
                    title={"BELI PRODUK CUP POLOSAN KAMI (LEBIH MURAH DARI MARKETPLACE!)"}
                    subtitle={
                        <>
                            Hanya dikirim cup dan paper box polosan ya <strong className="packaging-catalog-subtitle-highlight">(TANPA CUSTOM & TIDAK INCLUDE DESIGN)</strong>
                        </>
                    }
                    isReadyStock={1}
                />
                <OrderInstruction />
                <ConsultationBanner />
                {/* <Values /> */}
            </div>
        );
    }
}

export default Homepage;